import http from 'hub-http/clients/apiClient';
import httpHubless from 'hub-http/clients/noPortalApiClient';
const API_BASE = 'userpreferences/v1/profile/options';
export default class ProfileOptionsAPI {
  static getProfileOptions({
    hubless
  }) {
    if (hubless) {
      return httpHubless.get(`${API_BASE}/hubless`);
    }
    return http.get(API_BASE);
  }
}